
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { TokenModel } from "../typing/generalLoginType";
import { myfetchThunk } from "../../../app/myfetch";
import {loginActions} from "../actions/LoginAction";
import { masteruri } from "../../../config";
import { message } from "antd";
import { requestPath } from "../../PasswortZuruecksetzen/reset_logic";
// import { myfetchThunk } from "../../../app/myfetch";



export const requestLoginFromAPI =(username:string, password:string,
                                   history?:{push:(pfad:string)=>void}) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            masteruri+"/users/authenticate",
            {data:{Username:username,Password:password }},
            "POST",
            (payload:TokenModel) => {
                console.log("payl",payload)
                dispatch(loginActions.doLogin({Token:payload}));
                // pw_status 1 (Auslieferung): Das Konto arbeitet noch mit
                // einem Passwort, das jemand anderes vergeben hat. Die API
                // weist bis zum Wechsel jeden anderen Aufruf mit 403 ab.
                if (payload.pw_status === 1 && history) {
                    history.push("/passwortwechsel");
                }
            },
            ()=>{}
        ) as any)
    }
}

/**
 * Asks the hub for a one-time reset key (02.11.2026). The hub answers the same
 * for every name - whether the account exists is not told - so the page shows
 * that answer and nothing else. The key comes by mail; it is entered, with the
 * new password, on /passwort-zuruecksetzen.
 */
export const requestResetFromAPI =(username:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{
        dispatch(myfetchThunk(
            true,
            requestPath(masteruri),
            {Username:username},
            "POST",
            (payload:{message?:string}) => {
                message.info({content: payload?.message ?? "", duration: 8});
            },
            ()=>{}
        ) as any)
    }
}
